export default "__VITE_ASSET__CYaZTEZ4__"